import React from 'react';
import ReactDOM from 'react-dom/client';
import {
  init,
  mountMiniApp,
  mountViewport,
  requestViewport,
  requestSafeAreaInsets,
  requestContentSafeAreaInsets,
} from '@telegram-apps/sdk-react';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { ConfigProvider } from './ConfigContext';
import { PostHogProvider } from 'posthog-js/react';
import { TonConnectUIProvider } from "@tonconnect/ui-react";

(function () {
  const q = new URLSearchParams(window.location.search);
  const mock = q.get('mockTg'); // 'android' | 'ios' | null
  if (!mock) return;

  const plat = mock.toLowerCase();
  const top = Number(q.get('safeTop') || (plat === 'android' ? 56 : 48));
  const bottom = Number(q.get('safeBottom') || 0);

  window.Telegram = {
    WebApp: {
      platform: plat,
      viewport: {
        height: window.innerHeight,
        width: window.innerWidth,
        contentSafeAreaInsets: { top, bottom, left: 0, right: 0 },
        safeAreaInsets:       { top, bottom, left: 0, right: 0 },
      },
    }
  };

  // Also push CSS vars so layout adjusts even without SDK signals
  const rs = document.documentElement.style;
  rs.setProperty('--tg-safe-top', `${top}px`);
  rs.setProperty('--tg-safe-bottom', `${bottom}px`);
  rs.setProperty('--tg-safe-left', `0px`);
  rs.setProperty('--tg-safe-right', `0px`);
})();

// --- Only boot the SDK when *real* Telegram launch params are present ---
(function boot() {
  const search = new URLSearchParams(window.location.search);

  // Heuristics for "we are actually running inside Telegram":
  // 1) Telegram injects tgWebAppData (signed initData) OR tgWebAppPlatform in the URL
  // 2) Or the WebApp object exposes initData/initDataUnsafe
  const hasLaunchParams =
    search.has('tgWebAppData') ||
    search.has('tgWebAppPlatform') ||
    !!window?.Telegram?.WebApp?.initData ||
    !!window?.Telegram?.WebApp?.initDataUnsafe;

  if (!hasLaunchParams) {
    console.warn(
      '[sdk] Not initializing: no Telegram launch params detected. ' +
      'Running with fallback (your App.js will set safe-area via window.Telegram.WebApp.* if available).'
    );
    return;
  }

  if (window.__sdkMounted) return;

  try {
    init();                    // MUST be first
    mountMiniApp();            // bridge
    mountViewport();           // viewport
    requestViewport();
    requestSafeAreaInsets();   // hydrate viewport.safeAreaInsets signal
    requestContentSafeAreaInsets(); // hydrate viewport.contentSafeAreaInsets signal
    window.__sdkMounted = true;
    console.log('[sdk] initialized & mounted (launch params found)');

    const tg = window.Telegram?.WebApp;
    tg?.ready?.();
    tg?.expand?.();
    tg?.requestFullscreen?.();
    tg?.disableVerticalSwipes?.();
    
  } catch (err) {
    console.error('[sdk] init/mount failed:', err);
  }
})();

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <TonConnectUIProvider
      manifestUrl="https://tapnew.fmgames.io/tonconnect-manifest.json"
    >
      <PostHogProvider
        apiKey={process.env.REACT_APP_POSTHOG_KEY}
        options={{
          api_host: process.env.REACT_APP_POSTHOG_HOST,
          defaults: '2025-05-24',
          capture_exceptions: true,
          debug: process.env.NODE_ENV === 'development',
        }}
      >
        <ConfigProvider>
          <App />
        </ConfigProvider>
      </PostHogProvider>
    </TonConnectUIProvider>
  </React.StrictMode>
);

reportWebVitals();